<template>
  <div>
    <div
      class="arquivo-recebido"
      v-for="arquivo in informacoesArquivo"
      :key="arquivo.id"
    >
      <div>
        <ArquivoBase
          :tipoArquivo="arquivo.tipoArquivo"
          :objetoArquivo="arquivo.objetoArquivo"
          @arquivo-para-descricao="carregarArquivoParaDescricao"
          @baixar-arquivo="$emit('baixar-arquivo', arquivo.objetoArquivo.uuid)"
        />
      </div>
      <div class="linha-embaixo-arquivo-recebido" />
      <unicom-linha class="acoes-arquivo">
        <unicom-coluna class="ml-auto" sm="12" md="auto">
          <unicom-botao
            @click="$emit('reprovar-arquivo', arquivo.objetoArquivo)"
            :altura="30"
            tipo="secundario"
            :largura="150"
          >
            EXCLUIR
          </unicom-botao>
        </unicom-coluna>
      </unicom-linha>
    </div>
  </div>
</template>

<script>
import ArquivoBase from "../../../ListaArquivos/TiposArquivos/ArquivoBase.vue";
import { TIPOS_ARQUIVOS } from "../../../ListaArquivos/TiposArquivos/TiposArquivosEnum";

export default {
  components: {
    ArquivoBase
  },
  data() {
    return {
      statusAprovado: TIPOS_ARQUIVOS.APROVADO
    };
  },
  props: {
    informacoesArquivo: {
      type: Array,
      default: () => [
        {
          tipoArquivo: TIPOS_ARQUIVOS.ANALISE,
          objetoArquivo: {
            nomeArquivo: "Certificado.jpg",
            tamanhoArquivo: this.formatarBytes(100000),
            dataEnvio: "12/01/2020",
            mostrarIconeExcluir: false,
            descricao: "descricao arquivo"
          }
        }
      ]
    }
  },
  methods: {
    carregarArquivoParaDescricao(arquivo) {
      console.log("listas_arquivo_vue", arquivo);
      this.$emit("arquivo-para-descricao", arquivo);
    }
  },
  computed: {
    recuperarObjetoAcao() {
      const { id, uuid } = this.informacoesArquivo.objetoArquivo;

      return {
        id,
        uuid
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.arquivo-recebido {
  min-height: 50px;
  border-radius: 8px;
  box-shadow: 0px 2px 5px #00000029;
  background: #f1f2f1;

  .linha-embaixo-arquivo-recebido {
    margin: 0 24px;
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 3px;
  }

  .acoes-arquivo {
    padding: 10px;

    .texto-arquivo {
      width: 500px;
      padding-left: 20px;
    }
  }
}
</style>
